import { QuestionViewer } from "../../../SingleAssignment/componnets/questions/QuestionViewer";
import { Text } from "@core/text";
import { PRESETS } from "./constants";

interface VersionGridProps {
  currentPage: number;
  visibleGenerations: [string, unknown][];
  selectedVersion: number | null;
  onVersionSelect: (index: number) => void;
  t: (key: string) => string;
}

export const VersionGrid = ({
  currentPage,
  visibleGenerations,
  selectedVersion,
  onVersionSelect,
  t,
}: VersionGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 transition-all duration-300 transform">
      {visibleGenerations.map(([key, value], index) => {
        const parsedValue = JSON.parse(value as string);
        const questionData = parsedValue?.output ?? parsedValue;
        const promptId = parsedValue?.regenPrompt || "";

        const presetInfo = PRESETS.find(
          (preset) => preset.id === promptId || preset.prompt === promptId,
        );
        console.log(presetInfo);
        const displayPromptTitle = presetInfo
          ? t(`assignments.generator.preview.presets.${presetInfo.id}.title`)
          : promptId;
        const displayPromptDescription = presetInfo
          ? t(
              `assignments.generator.preview.presets.${presetInfo.id}.description`,
            )
          : "";
        const presetIcon = presetInfo?.icon || "";

        return (
          <div
            key={key}
            onClick={() => onVersionSelect(index)}
            className={`bg-white/90 dark:bg-gray-800/90 rounded-xl shadow-lg border-4 
              ${
                selectedVersion === currentPage * 2 + index
                  ? "border-green-500 dark:border-green-400"
                  : "border-gray-200/50 dark:border-gray-700/50"
              } 
              overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-xl 
              hover:-translate-y-1 animate-fade-in`}
            style={{
              animationDelay: `${index * 80}ms`,
            }}
          >
            <div className="p-4">
              <Text
                variant="span"
                className="text-sm font-medium mb-2 text-gray-600 dark:text-gray-300"
              >
                {t("assignments.generator.preview.version")}{" "}
                {currentPage * 2 + index + 1}
              </Text>

              <QuestionViewer
                index={currentPage * 2 + index + 1}
                question={questionData}
              />

              {promptId && (
                <div
                  className={`mt-3 p-3 rounded-lg ${presetInfo ? presetInfo.bgColor : "bg-gray-100 dark:bg-gray-700"} flex items-center gap-2`}
                >
                  {presetIcon && <span className="mr-1">{presetIcon}</span>}
                  <div className="flex flex-col">
                    <Text variant="h4" status="subtle">
                      {displayPromptTitle}
                    </Text>
                    <Text variant="p" status="subtle">
                      {displayPromptDescription}
                    </Text>
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
